import { selector } from '@poa/state';
import { makeGetTableGroupedSelector } from '../shared/table-grouping.selector';

const getTable = makeGetTableGroupedSelector('contactInfo');

export const filteredData = selector(store => {
  return getTable.get();
});
